import { render, staticRenderFns } from "./HeaderLang.vue?vue&type=template&id=58c4b978&scoped=true&"
import script from "./HeaderLang.vue?vue&type=script&lang=js&"
export * from "./HeaderLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4b978",
  null
  
)

export default component.exports